import api from '../../../services/api';
import { useState, useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import PageContainer from '../../../common/components/PageContainer';
import PageHeader from '../../../common/components/PageHeader';

function PropostaComercialOpcoes() {
    const [proposta, setProposta] = useState({});
    const { id } = useParams();

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/propostacomercial/${id}`);
                setProposta(response.data);
            } catch (error) {
                console.error('Erro ao buscar a proposta:', error);
            }
        }
        fetchData();
    }, [id]);

    const openPdf = async () => {
        try {
            const response = await api.get(`/propostacomercial/${id}/pdf`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <PageContainer>
            <PageHeader title={`${proposta.codigo || ''} ${proposta.cliente || ''}`} />

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                    <Card>
                        <CardActionArea component={Link} to={`/propostacomercial/${id}/editar`} sx={{ p: 3 }}>
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                <EditOutlinedIcon color="primary" sx={{ fontSize: 40 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Editar proposta</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card>
                        <CardActionArea onClick={openPdf} sx={{ p: 3 }}>
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                <PictureAsPdfOutlinedIcon color="secondary" sx={{ fontSize: 40 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Abrir PDF</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
        </PageContainer>
    );
}

export default PropostaComercialOpcoes;
